import { render, staticRenderFns } from "./SubstituirCaixa.vue?vue&type=template&id=584d6c33&scoped=true&"
import script from "./SubstituirCaixa.vue?vue&type=script&lang=js&"
export * from "./SubstituirCaixa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584d6c33",
  null
  
)

export default component.exports